import AddPaymentMethodSection from "../../components/NewDesign/Payment/AddPaymentMethodSection/AddPaymentMethodSection"
import PaymentOutlinePage from "../../components/PaymentOutlinePage"

const PaymentMethodAddPage = () => {
    return (
        <PaymentOutlinePage>
            <AddPaymentMethodSection />
        </PaymentOutlinePage>
    )
}

export default PaymentMethodAddPage